import React from 'react';
import { Plus, Filter, Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface BrandHeaderProps {
  showOnlyActiveFilter: boolean;
  onToggleActiveFilter: () => void;
  onOpenImport: () => void;
  onOpenAdd: () => void;
}

export const BrandHeader: React.FC<BrandHeaderProps> = ({
  showOnlyActiveFilter,
  onToggleActiveFilter,
  onOpenImport,
  onOpenAdd,
}) => {
  return (
    <div className="flex justify-between items-center mb-6 shrink-0">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Brand Management</h1>
        <p className="text-gray-600">Manage your brand partnerships and client relationships</p>
      </div>
      <div className="flex items-center space-x-3">
        <Button
          variant={showOnlyActiveFilter ? "default" : "outline"}
          onClick={onToggleActiveFilter}
          className="flex items-center space-x-2"
        >
          <Filter className="w-4 h-4" />
          <span>{showOnlyActiveFilter ? 'Show All' : 'Active Campaigns Only'}</span>
        </Button>
        <Button
          variant="outline"
          onClick={onOpenImport}
        >
          <Upload className="w-4 h-4" />
          <span>Import CSV</span>
        </Button>
        <Button
          onClick={onOpenAdd}
        >
          <Plus className="w-4 h-4" />
          <span>Add Brand</span>
        </Button>
      </div>
    </div>
  );
};
